import React, { useState } from "react";
import { icons } from "icons";
import { connect } from "react-redux";
import FileUploader from "Utils/FileUploader/FileUploader";
import FileUploaderCrop from "Utils/FileUploader/FileUploaderCrop";
import Select from "react-select";

import { Field, reduxForm, formValueSelector, FieldArray } from "redux-form";
import {
    renderNumber,
    renderSelectField,
    renderField,
    renderCurrency,
} from "Utils/renderField/renderField";




const SettingToggle = ({ name, title, description, videos = [], onOpenModal }) => {

  const handleClick = (e) => {
    e.preventDefault();
    if (onOpenModal && videos.length > 0) {
      onOpenModal(videos);
    }
  };

  return (
    <div className="d-flex align-items-start">
      <div style={{ marginRight: '10px' }} className="d-flex align-items-center">
        <label className="switch m-0">
          <Field name={name} component="input" type="checkbox" />
          <span className="slider round" />
        </label>
      </div>

      <div>
        <label htmlFor={name} className="form-label fw-bold">
          {title}
        </label>

        <p className="text-muted mb-0" style={{ fontSize: '14px' }}>
          {description}
        </p>

        {videos.length > 0 && (
          <a
            href="#"
            className="text-dark d-inline-flex align-items-center mt-1"
            onClick={handleClick}
          >
            Más información
            <img
              title="Más información"
              src={icons.abrir_enlace}
              alt="Más información"
              style={{
                width: '16px',
                height: '16px',
                marginRight: '6px',
                objectFit: 'contain',
              }}
            />
          </a>
        )}
      </div>
    </div>
  );
};

export default SettingToggle;